import React from 'react';
import { Dialog } from '@headlessui/react';
import { Share2, X } from 'lucide-react';
import { useProducts } from '../../context/ProductContext';
import { useShare } from '../../hooks/useShare';
import { ProductImage } from './ProductImage';
import { ProductPrice } from './ProductPrice';

interface ProductDetailProps {
  productId: string;
  onClose: () => void;
}

export const ProductDetail: React.FC<ProductDetailProps> = ({ productId, onClose }) => {
  const { products } = useProducts();
  const { handleShare } = useShare();
  
  const product = products.find(p => p.id === productId);
  
  if (!product) return null;

  return (
    <Dialog open={true} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-2xl w-full bg-white rounded-xl shadow-lg">
          <div className="relative">
            <button
              onClick={onClose}
              className="absolute right-4 top-4 text-gray-500 hover:text-gray-700 z-10"
            >
              <X size={24} />
            </button>
            <ProductImage src={product.thumbnail} alt={product.display_name} />
          </div>

          <div className="p-6">
            <div className="flex justify-between items-start">
              <div>
                <Dialog.Title className="text-2xl font-bold">
                  {product.display_name}
                </Dialog.Title>
                <p className="text-gray-600">{product.brand}</p>
              </div>
              <button
                onClick={() => handleShare(product)}
                className="flex items-center gap-2 px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600"
              >
                <Share2 size={20} />
                Compartir
              </button>
            </div>

            <div className="mt-4 space-y-4">
              <ProductPrice
                currentPrice={product.current_price}
                previousPrice={product.previous_price}
                isDiscounted={product.price_decreased}
              />

              <div>
                <h3 className="font-semibold text-gray-700">Descripción</h3>
                <p className="text-gray-600">{product.description}</p>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <h3 className="font-semibold text-gray-700">Categoría</h3>
                  <p className="text-gray-600">{product.category_name}</p>
                </div>
                {product.price_decreased && (
                  <div>
                    <h3 className="font-semibold text-gray-700">Ahorro</h3>
                    <p className="text-green-600 font-semibold">
                      {(product.previous_price - product.current_price).toFixed(2)}€
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};